import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NoticeBoardWidgetComponent } from "@feature/_app_modules/notice-board-widget/containers/notice-board-widget.component";
import { NoticeBoardBodyComponent } from "@feature/_app_modules/notice-board-widget/components/notice-board-body.component";
import {CompositeDetailsModule} from "@feature/_app_modules/composite-details/composite-details.module";

@NgModule({
  declarations: [
    NoticeBoardWidgetComponent,
    NoticeBoardBodyComponent
  ],
  exports: [
    NoticeBoardWidgetComponent,
    NoticeBoardBodyComponent
    ],
  imports: [
    CompositeDetailsModule,
    CommonModule,
    SharedModule
    ],
})
export class NoticeBoardWidgetModule { }
